import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SeoGetSlug } from '../../services';

export const fetchSeoGetSlug = createAsyncThunk(
    'seoGetSlug/fetchSeoGetSlug',
    async ({ slug }) => {
        const response = await SeoGetSlug(slug)
        return response.result
    }
);

const seoGetSlugSlice = createSlice({
    name: 'seoGetSlug',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoGetSlug.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoGetSlug.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoGetSlug.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoGetSlugSlice.reducer;
